export default {"src":"/_next/static/media/warehouses.8a59812e.svg","height":50,"width":50};